var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toggleOneClickMode as toggleOneClickModeAction, setOneClickAmount as setOneClickAmountAction, } from '../../../actions/creators/BettingMode';
import Switcher from '../Switcher';
import { minAmount } from '../../../constants/StakeMinAmount';
import { resourceNames } from '../../../constants/accountResourceNames';
function OneTouchBet(props) {
    var bettingMode = props.bettingMode;
    var toggledOneTouchBet = bettingMode.isOneClickOn;
    var toggledDivClassName = toggledOneTouchBet ? 'toggle-div__inner toggled' : 'toggle-div__inner';
    var oneClickAmount = bettingMode.oneClickAmount;
    var min = minAmount[resourceNames[props.accountResourceId]];
    function onBlur() {
        if (oneClickAmount >= min) {
            props.setOneClickAmountAction(oneClickAmount);
        }
        else {
            props.setOneClickAmountAction(min);
        }
    }
    return (_jsxs("div", __assign({ className: 'one-touch-block' }, { children: [_jsx(Switcher, { switcherTxt: props.switcherTxt, onclick: props.toggleOneClickModeAction, class: toggledDivClassName }), toggledOneTouchBet &&
                _jsx("div", __assign({ className: 'stake-variants__inputs' }, { children: _jsx("div", __assign({ className: 'one-touch-input' }, { children: _jsx("input", { name: 'one-touch-bet', value: oneClickAmount, className: 'fstake-input', type: 'tel', pattern: '[0-9]*', onClick: function (e) { return e.target.value = ''; }, onChange: function (e) { return props.setOneClickAmountAction(e.target.value); }, onBlur: onBlur, maxLength: '10' }) })) }))] })));
}
OneTouchBet.propTypes = {
    toggleOneClickModeAction: PropTypes.func.isRequired,
    setOneClickAmountAction: PropTypes.func.isRequired
};
var mapStateToProps = function (state) { return ({
    bettingMode: state.application.get('bettingMode'),
    accountResourceId: state.application.get('auth').user.accountResourceId,
}); };
export default connect(mapStateToProps, {
    toggleOneClickModeAction: toggleOneClickModeAction,
    setOneClickAmountAction: setOneClickAmountAction
})(OneTouchBet);



// WEBPACK FOOTER //
// ./src/components/sidebar/settings/OneTouchBet.jsx